import { ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import GrowthIntegrationStatus from "@/components/GrowthIntegrationStatus";
import GrowthAIOperator from "@/components/GrowthAIOperator";
import GrowthCampaigns from "@/pages/GrowthCampaigns";
import ClientOpportunities from "@/pages/ClientOpportunities";
import ClientServices from "@/pages/ClientServices";

export default function GrowthHub() {
  const { user } = useAuth();
  const canManage = ["admin", "ops_manager"].includes(user?.role);

  if (!canManage) {
    return (
      <div className="mx-auto max-w-3xl rounded-xl border bg-card p-8 text-center" data-testid="growth-agent-restricted">
        <ShieldCheck className="mx-auto h-8 w-8 text-[#315A7D]" />
        <h1 className="mt-3 font-heading text-xl font-bold">Growth Engine</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Campaign creation and audience management are controlled by your agency Administrator or Operations Manager.
          Your assigned leads, follow-ups, appointments, policies and commissions remain available in your Agent workspace.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div>
        <h1 className="font-heading text-2xl font-bold">Growth</h1>
        <p className="text-sm text-muted-foreground">
          Acquire, convert, grow, and retain clients through one shared campaign framework.
        </p>
      </div>
      <Tabs defaultValue="opportunities">
        <TabsList>
          <TabsTrigger value="opportunities" data-testid="tab-client-opportunities">Client Opportunities</TabsTrigger>
          <TabsTrigger value="services" data-testid="tab-client-services">Client Services</TabsTrigger>
          <TabsTrigger value="acquisition" data-testid="tab-acquisition">Acquisition (Final Expense)</TabsTrigger>
        </TabsList>
        <TabsContent value="opportunities">
          <ClientOpportunities />
        </TabsContent>
        <TabsContent value="services">
          <ClientServices />
        </TabsContent>
        <TabsContent value="acquisition">
          <GrowthIntegrationStatus />
          <GrowthAIOperator />
          <GrowthCampaigns />
        </TabsContent>
      </Tabs>
    </div>
  );
}
